import * as React from 'react'
import Dialog from 'material-ui/Dialog'
import TextField from 'material-ui/TextField'
import {errorMessage} from '../../Data/FormValidation'
import {ProductCalculationImportAction} from './ProductCalculationImportActions'
import {
    CreateMessageModalInput,
    ProductCalculationImportState
} from './ProductCalculationImportState'
import {Tabs, Tab} from 'material-ui'
import FlatButton from 'material-ui/FlatButton'

export function ProductCalculationImportCreateMessageModal({state, dispatch}: {
    state: ProductCalculationImportState,
    dispatch: (action: ProductCalculationImportAction) => void,
}) {
    return (
        <div>
            <Dialog
                title="Fehlende Einträge erstellen"
                modal={true}
                open={state.createMessageModal.open}
            >
                <Tabs>
                    {(state.createMessageModal.type.needCreation && !(state.form.type.wasRecentlyCreated))
                    && CreateMessageModalTab(
                        state.createMessageModal.type, dispatch,
                        'type',
                        state.createMessageModal.saving
                    )}
                    {(state.createMessageModal.format.needCreation && !(state.form.format.wasRecentlyCreated))
                    && CreateMessageModalTab(
                        state.createMessageModal.format,
                        dispatch,
                        'format',
                        state.createMessageModal.saving
                    )}
                    {(state.createMessageModal.coverage.needCreation && !(state.form.coverage.wasRecentlyCreated))
                    && CreateMessageModalTab(
                        state.createMessageModal.coverage,
                        dispatch,
                        'coverage',
                        state.createMessageModal.saving
                    )}
                    {(state.createMessageModal.print.needCreation && !(state.form.print.wasRecentlyCreated))
                    && CreateMessageModalTab(
                        state.createMessageModal.print,
                        dispatch,
                        'print',
                        state.createMessageModal.saving
                    )}
                    {(state.createMessageModal.paper.needCreation && !(state.form.paper.wasRecentlyCreated))
                    && CreateMessageModalTab(
                        state.createMessageModal.paper,
                        dispatch,
                        'paper',
                        state.createMessageModal.saving
                    )}
                    {(state.createMessageModal.processing.needCreation && !(state.form.processing.wasRecentlyCreated))
                    && CreateMessageModalTab(
                        state.createMessageModal.processing,
                        dispatch,
                        'processing',
                        state.createMessageModal.saving
                    )}
                </Tabs>
            </Dialog>
        </div>
    )
}

function CreateMessageModalTab(
    messageModalInput: CreateMessageModalInput,
    dispatch: (action: ProductCalculationImportAction) => void,
    key: string,
    saving: null | string
) {
    return (
        <Tab label={messageKeyToName(key)}>
            <div>
                <div style={{width: '100%', boxSizing: 'border-box', padding: '8px'}}>
                    <TextField
                        style={{width: '100%'}}
                        floatingLabelText="Deutscher Begriff"
                        value={messageModalInput.translation}
                        onChange={(event, value) => dispatch({
                            type: 'NewMessageInputChange',
                            key: key,
                            language: 'DE',
                            value: value
                        })}
                        errorText={errorMessage(messageModalInput.translationValidation)}
                    /><br/>
                    <TextField
                        style={{width: '100%'}}
                        floatingLabelText="Englischer Begriff"
                        value={messageModalInput.text}
                        onChange={(event, value) => dispatch({
                            type: 'NewMessageInputChange',
                            key: key,
                            language: 'EN',
                            value: value
                        })}
                        errorText={errorMessage(messageModalInput.textValidation)}
                    /><br/>
                    <div style={{clear: 'both', height: '32px'}} />
                    <FlatButton
                        label={
                            saving !== null
                                ? messageKeyToName(saving) + ' wird gespeichert...'
                                : messageKeyToName(key) + ' speichern & eintragen'
                        }
                        style={{float: 'right'}}
                        disabled={saving !== null}
                        onClick={() => dispatch({
                            type: 'SaveMessageKey',
                            key: key
                        })}
                    />
                    <FlatButton
                        label="Später fortsetzen"
                        style={{float: 'right'}}
                        onClick={() => dispatch({
                            type: 'CloseMessageModal'
                        })}
                    />
                </div>
            </div>
        </Tab>
    )
}

function messageKeyToName(key: string) {
    switch (key) {
        case 'type':
            return 'Typ'
        case 'format':
            return 'Format'
        case 'coverage':
            return 'Umfang'
        case 'print':
            return 'Druck'
        case 'paper':
            return 'Papier'
        case 'processing':
            return 'Verarbeitung'
        default:
            return ''
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationImport/ProductCalculationImportCreateMessageModal.tsx